import React from "react";
import * as styles from "./blogSideBar.module.css";
import { useStaticQuery, Link, graphql } from "gatsby";
import Subscribe from "./../../home/subscribe/Subscribe";
import SocialShare from "./../../../components/SocialShare";

const isBrowser = () => typeof window !== "undefined";

const bestTools = [
  {
    url: "https://www.sleeplessyogi.com/Etsy",
    name: "Etsy",
    price: "Free",
  },
  // {
  //   url: "https://www.sleeplessyogi.com/EtsyHunt",
  //   name: "Etsy Hunt",
  //   price: "Free",
  // },
  {
    url: "https://www.sleeplessyogi.com/Printify",
    name: "Printify",
    price: "Free",
  },
  {
    url: "https://www.printful.com/give-5-get-5/KTE16E",
    name: "Printful",
    price: "Free",
  },
  {
    url: "https://www.shopify.com/",
    name: "Shopify",
    price: "$1/mo (3 months)",
    color: "orange",
  },
  {
    url: "https://www.sleeplessyogi.com/EtsyHunt",
    name: "Etsy Hunt",
    price: "Free",
  },
  {
    url: "https://www.sleeplessyogi.com/Alura",
    name: "Alura",
    price: "Free",
  },
];

const BlogSideBar = () => {
  const data = useStaticQuery(graphql`
    {
      allMdx(
        sort: { fields: frontmatter___date, order: DESC }
        skip: 0
        limit: 8
      ) {
        posts: edges {
          node {
            frontmatter {
              date
              slug
              title
              tags
              description
              og_image {
                publicURL
              }
            }
          }
        }
      }
    }
  `);

  const { posts } = data.allMdx;

  return (
    <div className={styles.rightBar}>
      <div className={`${styles.rightBox} p-4`}>
        <h3>Best E-Commerce Tools</h3>
        {bestTools.map((t) => (
          <a href={t.url} class="">
            <div class="grid grid-cols-2 gap-2 sm:grid-cols-2 mb-2">
              <p class="">{t.name}</p>
              <p className={`text-${t.color || "green"}-500`}>{t.price}</p>
            </div>
          </a>
        ))}
      </div>
      <div className={styles.rightBox}>
        <h3>Latest Posts</h3>
        {posts.map((post, index) => {
          const postData = post.node.frontmatter;

          return (
            <Link to={`/posts/${postData.slug}/`} key={index}>
              <div className={styles.slider_card}>
                <svg
                  class="mt-1 mr-2 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M1 5h12m0 0L9 1m4 4L9 9"
                  />
                </svg>{" "}
                <p className={styles.title}>{postData.title}</p>
              </div>
            </Link>
          );
        })}
      </div>
      <div className={styles.rightBox}>
        {/* promo */}
        <a href="https://etsy.me/3OhN5Yk" target="_blank">
          <img
            src="https://i.imgur.com/A7fTREB.webp"
            alt="Try Etsy For Free"
          ></img>
        </a>
        <br />
      </div>
      <div className={styles.rightBox}>
        <h3>Best Selling Books</h3>
        <div className={styles.card}>
          <Link
            to="https://ngninja.gumroad.com/l/html2react/blog"
            target="_blank"
            title="HTML To React"
          >
            <div className={styles.slider_card}>
              <img src="https://i.imgur.com/b4WXorY.webp" alt="HTML To React" />
            </div>
          </Link>
        </div>
        <div className={styles.card}>
          <Link
            to="https://ngninja.gumroad.com/l/bizBook/blog"
            target="_blank"
            title="Make Money on Instagram"
          >
            <div className={styles.slider_card}>
              <img
                src="https://i.imgur.com/c3vv4Sx.webp"
                alt="Make Money on Instagram"
              />
            </div>
          </Link>
        </div>
      </div>

      <div className={styles.rightBox}>
        <h3>Newsletters in your inbox</h3>
        <Subscribe></Subscribe>
      </div>
      <div className={styles.rightBox}>
        <h3>Share This Post</h3>
        <SocialShare
          getSocialShareTitle={() =>
            `${
              isBrowser() ? `${window.document.title} by @sleeplessyogi` : ""
            }\n`
          }
        ></SocialShare>
      </div>
    </div>
  );
};

export default BlogSideBar;
